import { log } from './LogHelper';

export class GoogleFitHealth {
  userId: number;

  constructor(userId: number) {
    this.userId = userId;
  }

  disconnect() {
    log('GoogleFit disconnect unavailable');
  }

  async authorize() {
    log('GoogleFit authorize unavailable');
  }

  async getIsGoogleFitAuthorized(): Promise<boolean> {
    log('GoogleFit status not available');
    return false;
  }

  async getDataToSynchronize(progress: (message: string) => void) {
    log('GoogleFit no data to sync');
    return [] as any[];
  }

  async synchronizeData() {
    log('GoogleFit no data to sync');
  }
}
